<template>
  <div class="allbills-log-container">
    <mytable
      :maxHeight="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsMoreList="btnsMoreList"
      :btnsList="btnsList"
      :Operatewidth="0"
    ></mytable>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/table.vue";
export default {
  mixins: [tableListNew],
  components:{
    mytable
  },
  props: {
    waybillSplitId: {},
  },
  data() {
    return {
      align: "center",
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: false, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "财务明细", //按钮名称
          methods: "WaybillEdit", //当前页面的方法
          param: 1, //自定义参数标记
          permission: "aaaaa",
        }
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
      ],
      pageGroupName: "admin_waybill_all_bill", //  页面标识
      reportFiledsNumber: "admin_waybill_all_bill", // 动态 条件、表头
    };
  },
  mounted(){
    if(!this.waybillSplitId){
      return
    }
    this.getData({
      waybillSplitId:this.waybillSplitId
    })
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.tableData = []
        }
        this.getData({
          waybillSplitId:val
        })
      },
    },
  },
};
</script>

<style scoped lang="less">
.allbills-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}
</style>